// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__5rLCC","balanceDisclaimer":"posDashboard_balanceDisclaimer__3oPxJ"};